import * as React from "react";

import { Colors } from "@blueprintjs/core";
import { addBreadcrumb, captureException } from "@sentry/core";
import { IModerationOption } from "~/graphql/queries/optionApproval/optionsPendingApproval";
import styled from "~/styled";

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
`;

const Wrapper = styled.div`
  border: 10px solid #0003;
  border-radius: 3px;
  position: relative;

  &[data-reject="true"] {
    border-color: ${Colors.RED3};
  }

  &[data-reject="false"] {
    border-color: ${Colors.GREEN3};
  }
`;

interface IProps {
  isApproved: boolean;
  isRejected: boolean;
  moderationOption: IModerationOption;
  onApprove: (moderationOptionId: string) => void;
  onReject: (moderationOptionId: string) => void;
}

export default class ApprovalOption extends React.Component<IProps> {
  public render() {
    const { moderationOption, isRejected } = this.props;

    if (!moderationOption.image) {
      this.reportModerationOptionImageMissingError(moderationOption);
      return null;
    }

    return (
      <Wrapper onClick={this.handleClick} data-reject={isRejected}>
        <Image src={moderationOption.image.imageUrl} />
      </Wrapper>
    );
  }

  private handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();

    const { id: moderationOptionId } = this.props.moderationOption;
    if (this.props.isRejected) {
      this.props.onApprove(moderationOptionId);
    } else {
      this.props.onReject(moderationOptionId);
    }
  };

  private reportModerationOptionImageMissingError(
    moderationOption: IModerationOption
  ) {
    addBreadcrumb({
      data: {
        moderationOptionId: moderationOption.id
      },
      message: "Rendering ApprovalOption for moderationOption"
    });
    captureException(
      new TypeError(
        `Expected moderationOption to have an image, found ${
          moderationOption.image
        }`
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductOptionApproval/ApprovalOption.tsx